import { render, staticRenderFns } from "./CompetitionEventsItem.vue?vue&type=template&id=0e269b2e&scoped=true"
import script from "./CompetitionEventsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionEventsItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompetitionEventsItem.vue?vue&type=style&index=0&id=0e269b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e269b2e",
  null
  
)

export default component.exports